import styled from 'styled-components';
export const LangDrawerContainer = styled.div `
  display: flex;
  flex-direction: column;
  /*
   * O corpo do drawer é flex: sem isso o conteúdo manda na largura, e as
   * opções mudavam de tamanho conforme o texto exibido.
   */
  flex: 1;
  min-width: 0;
  /* 24px nas laterais: mesma coluna do título do drawer. */
  padding: 24px 24px 32px;

  .drawer-lang_description {
    font-size: var(--font-size-sm);
  }

  .drawer-lang_body {
    flex-grow: 1;
    display: flex;
    margin-top: 24px;
    flex-direction: column;
  }

  .drawer-lang_footer {
    gap: 24px;
    display: flex;
    padding: 16px 20px;
    align-items: center;
    background-color: var(--color-feedback-warning-100);

    img {
      width: 24px;
      height: 24px;
      padding: 8px;
      border-radius: var(--border-radius-circular);
      background-color: var(--color-feedback-warning-400);
    }

    div {
      gap: 8px;
      display: flex;
      flex-direction: column;

      p {
        margin: 0;
        font-size: var(--font-size-sm);
      }

      p.drawer-lang_footer-title {
        font-size: var(--font-size-default);
        font-weight: var(--font-weight-semibold);
      }
    }
  }
`;
//# sourceMappingURL=style.js.map